const stonlyIdentifyWidget = (email, name) => {
  if (!email) return;
  globalThis.StonlyWidget?.("identify", email, { "nom-utilisateur": name, email });
};

export { stonlyIdentifyWidget };
